/// <reference path="./TaskAction.ts"/>

module Shared {
    // $Classes/Enums/Interfaces(filter)[template][separator]
    // filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
    // template: The template to repeat for each matched item
    // separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]

    // More info: http://frhagn.github.io/Typewriter/

    
    export class Task  {
        
        // TASKTITLE
        public taskTitle: string = null;
        // COMPLETEDDATE
        public completedDate: Date = null;
        // TASKACTIONS
        public taskActions: TaskAction[] = [];
        // TASKCODE
        public taskCode: string = null;
        // BUSINESS
        public business: boolean = false;
    }

    export class TaskObject {
        public title: string = null;
        public type: string = null;
        public startsAt: moment.Moment = null;
        public endsAt: moment.Moment = null;
        public action_Web_Task_no: string = null;
        public status: string = null;
        public actionId: string = null;
        public actionTitle: string = null;
        public timestamp: moment.Moment = null;
        public events: Array<any> = null;
        public highlightMonth: boolean = false;
    }

}
